module.exports = __webpack_public_path__ + "img/error.25d5d72e.png";